import EnoviaService from "./Services/enoviaService.js";
let Service = {
    EnoviaService: (path, option) => new EnoviaService(path, option),
};

export { Service as default };